/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ChatGeneralFeedback = {
    id: string;
    issueType?: ChatGeneralFeedback.issueType | null;
    details: string;
    createdAt: string;
    updatedAt: string;
};

export namespace ChatGeneralFeedback {

    export enum issueType {
        NOT_CORRECT = 'not_correct',
        UNFOLLOW_INSTRUCTIONS = 'unfollow_instructions',
        OTHER = 'other',
    }


}

